// 引入全局组件
import { filters, filter, moment } from './filter'

//引入表格组件
// import 'xe-utils'
// import 'vxe-table/lib/style.css'
import 'vxe-table/lib/header/style/style.css'
import 'vxe-table/lib/column/style/style.css'
import 'vxe-table/lib/table/style/style.css'
import 'vxe-table/lib/edit/style/style.css'
import 'vxe-table/lib/icon/style/style.css'
import {
  // 核心
  // VXETable,
  Header,
  Footer,
  Edit,
  Column,
  // 表格
  Validator,
  Table,
} from 'vxe-table'
//
// //项目配置文件
// import appMain from "./appMain";
// 自定义组件
import previewPictureForSimple from './previewPictureForSimple'
import previewPicture from './previewPicture'
import previewAttachment from './previewAttachmentPlus/components/previewAttachment'
import previewAttachmentPlus from './previewAttachmentPlus'
import showAttachment from './previewAttachmentPlus/components/showAttachment'
import uploadAttachment from './previewAttachmentPlus/components/uploadAttachment'
import uploadNormal from './previewAttachmentPlus/components/uploadNormal'
import uploadModal from './previewAttachmentPlus/components/uploadModal/index.js'
import headerTit from './headerTit'
import crudQuery from './crudQuery'
import shortcutQuery from './crudQuery/shortcutQuery.vue'
import crudDoubleQuery from './crudQuery/crudDoubleQuery'
import crudQueryAndFullScreen from './crudQuery/crudQueryAndFullScreen'
import fullscreen from './fullscreen/fullscreen.vue'
import crudSpectaculars from './crudSpectaculars'
import crudQuerys from './crudQuerys'
import crudDoubleQuerys from './crudDoubleQuerys'
import queryToolbar from './queryToolbar'
import crudEdit from './crudEdit'
import crudEditOrder from './crudEditOrder'
import crudEditForSideModal from './crudEditForSideModal'
import crudQueryForSideModal from './crudQueryForSideModal'
import anchorGo from './anchorGo'
import panguSpin from './panguSpin'
import anchorGoLink from './anchorGoLink'
import navigation from './navigation'
import copyright from './copyright'
import panguSideModal from './panguSideModal'
import sideContainsComponent from './sideContainsComponent'
import imageEditor from './imageEditor'
import panguDraggableList from './panguDraggableList'
import shuttleBoxModal from './shuttleBoxModal'
import shuttleBoxSide from './shuttleBoxSide'
import draggableContainer from './draggableContainer/draggableContainer.vue'
import draggableTreeContainer from './draggableTreeContainer/draggableTreeContainer.vue'
import treeClassify from './treeClassify/treeClassify.vue'
import handle from './treeClassify/handle/handle.vue'
import leadLoading from './leadLoading/leadLoading.vue'
import approvalStepDisplay from './approvalStepDisplay/approvalStepDisplay.vue'
import approvalTimelineModal from './approvalTimelineModal/approvalTimelineModal.vue'
import panguPopTip from './panguPopTip/panguPopTip.vue'
import tableOfSideModal from './tableOfSideModal/tableOfSideModal.vue'
import confirmTip from './confirmTip/confirmTip.vue'
import yearSelectModel from './yearSelectModel/yearSelectModel.vue'
import emptyPage from './emptyPage/emptyPage.vue'
import returnTop from './returnTop/returnTop.vue'
import queryGroup from './queryGroup/queryGroup.vue'
import saveTemplateModal from './saveTemplateModal/saveTemplateModal.vue'
import depositCalcModal from './editform/depositCalc/depositCalcModal.vue'
import depositCalcSide from './editform/depositCalc/depositCalcSide.vue'
import depositCalcUse from './editform/depositCalc/depositCalcUse.vue'
import dynamicFrom from './dynamicFrom'
import popTipOfMessage from './popTipOfMessage/popTipOfMessage.vue'
import pollMessage from './pollMessage/pollMessage.vue'
import modalProgress from './modalProgress/modalProgress.vue'
import modalAlike from './modalAlike/modalAlike.vue'
import modalUpdateResult from './modalUpdateResult/modalUpdateResult.vue'
import modalCheckUpdate from './modalCheckUpdate/modalCheckUpdate.vue'
import buttonOfSynchroData from './buttonOfSynchroData/buttonOfSynchroData.vue'
import modalFrom from './modalFrom/modalFrom.vue'
import batchReplaceModel from './batchReplaceModel/batchReplaceModel.vue'
import batchReplaceModelPlus from './batchReplaceModel/batchReplaceModelPlus.vue'
import batchUpdateAmountModal from './batchUpdateAmountModal/batchUpdateAmountModal.vue'
import topRemind from './topRemind/topRemind.vue'
import newTopRemind from './newTopRemind/newTopRemind.vue'
import sendIbpHint from './sendIbpHint/sendIbpHint.vue'
import findBi from './findBi/findBi.vue'
import handleTip from './handleTip/handleTip.vue'
import copyExcelInput from './copyExcelInput/copyExcelInput.vue'
import messageNeedCare from './messageNeedCare/messageNeedCare.vue'
import downloadApp from './layoutTemplate/downloadApp.vue'
import progressTask from './progressTask/progressTask.vue'
import htmlText from './editform/htmlText/htmlText.vue'
import jumpManage from './editform/jumpManage/jumpManage.vue'
import portal from './portal/index'
import portalItem from './portal/portalItem.vue'
import ErrorPage404 from './error-404/error404.vue'
import productCatlog from './productCatlog/productCatlog.vue'
import productCard from './productCard/productCard.vue'
import productCardForGood from './productCardForGood/productCardForGood.vue'
import acdSee from './acdSee/acdSee.vue'
import productDetail from './productDetail/productDetail.vue'
import productCart from './productCart/productCart.vue'
import productSupplement from './productSupplement/productSupplement.vue'
import addGoods from './addGoods/addGoods.vue'
import panguTab from './panguTab/panguTab.vue'
import goodLists from './goodLists/goodLists.vue'
import goodQuery from './goodQuery'
import goodQueryBh from './goodQuery/goodQuery-bh.vue'
import productNav from './productNav/productNav.vue'
import productProcess from './productProcess/productProcess.vue'
import SideDoubleTableSelect from './side-double-table-select/SideDoubleTableSelect'
import SideTableSelect from './side-table-select/SideTableSelect'
import { bookKeeping, bookKeepingForMink } from './bookKeeping'
import upAndDown from './upAndDown'
import popupSelection from './popupSelection'
import queryGroupPlus from './queryGroupPlus/queryGroupPlus.vue'
import scanNumberAndPopUp from './scanNumberAndPopUp/scanNumberAndPopUp.vue'
import modalScanNumberAndPopUp from './modalScanNumberAndPopUp/modalScanNumberAndPopUp.vue'
// 按需引入组件

import crudEditOfDesign from './crudEditOfDesign'

// 动态表单组件
// import formCreate from './form-create';
import dynamicFromItem from './dynamicFrom/dynamicFromItem.vue'
import sideTableSubmitForm from './editform/sideTableSubmitForm'
import selectRemote from './editform/selectRemote'
import panguSelect from './editform/panguSelect'
import sideSetScope from './editform/sideSetScope'
import sideAsynRefresh from './editform/sideAsynRefresh'
import sideExport from './editform/sideExport'
import sideAddLicenses from './editform/sideAddLicenses'
import panguTag from './editform/panguTag'
import selectOfModalTable from './editform/selectOfModalTable'
import keywordOfModalTable from './editform/keywordOfModalTable'
import inputSelectOfModalTable from './editform/inputSelectOfModalTable'
import referencePrice from './editform/referencePrice/index'
import keywordSearchTable from './editform/keywordSearchTable'
import treeEdit from './editform/treeEdit'
import treeEditRole from './editform/treeEditRole'
import objectJsonEdit from './editform/objectJsonEdit'
import objectJsonEditAPI from './editform/objectJsonEditAPI'
import inputJson from './editform/inputJson'
import panguTable from './editform/panguTable'
import modelInputNumber from './editform/panguTable/modelInputNumber.vue'
import crudArray from './editform/crudArray'
import fMSuperSearchModal from './editform/fMSuperSearchModal'
import fMSuperForProductSearchModal from './editform/fMSuperForProductSearchModal'
import crudArrayOrder from './editform/crudArrayOrder'
import dataTable from './editform/dataTable'
import crudDataTable from './editform/crudDataTable'
import readTextPlus from './editform/readTextPlus'
import readText from './editform/readText'
import readTextTwo from './editform/readTextTwo'
import arrToStr from './editform/arrToStr'
import cascaderRemote from './editform/cascaderRemote'
import groupLabel from './editform/groupLabel/groupLabel.vue'
import groupBlank from './editform/groupBlank/groupBlank.vue'
import groupDashed from './editform/groupDashed/groupDashed.vue'
import emptyItem from './editform/emptyItem/emptyItem.vue'
import editInTable from './editform/editInTable/editInTable.vue'
import workflowDiagramEdit from './workflowDiagram/workflowDiagramEdit.vue'
import cellStatus from './editform/cellStatus'
import tagColor from './editform/tag-color'
import readTextColorAndTitle from './editform/read-text-color-and-title'
import newCellStatus from './editform/newCellStatus'
import commonPartShow from './editform/commonPartShow'
import iconSelect from './editform/iconSelect'
import radioRemote from './editform/radioRemote'
import checkboxRemote from './editform/checkboxRemote'
import panguAutoComplete from './editform/panguAutoComplete'
import treeOfModal from './editform/treeOfModal'
import storageCondition from './editform/storageCondition'
import auditComent from './editform/auditComent'
import proportion from './editform/proportion'
import proportionWithUnit from './editform/proportionWithUnit'
import { formItemClick, goodsItemClick } from './editform/formItemClick/index.js'
import cellBoolean from './editform/cellBoolean/cellBoolean.vue'
import flashAddMedical from './editform/flashAddMedical/flashAddMedical.vue'
import excelCopyForFlash from './editform/flashAddMedical/excelCopy/excelCopy.vue'
import flashAddMedicalForProduct from './editform/flashAddMedicalForProduct/flashAddMedicalForProduct.vue'
import flashAddMedicalEidt from './editform/flashAddMedicalEidt/flashAddMedicalEidt.vue'
import flashAddMedicalModalTable from './editform/flashAddMedicalModalTable/flashAddMedicalModalTable.vue'
import flashAddMedicalLight from './editform/flashAddMedicalLight/flashAddMedicalLight.vue'
import flashAddMedicalSuper from './editform/flashAddMedicalSuper/flashAddMedicalSuper.vue'
import flashAddMedicalSuperForProduct from './editform/flashAddMedicalSuperForProduct/flashAddMedicalSuperForProduct.vue'
import treeTable from './editform/treeTable/treeTable.vue'
import treeCodeInput from './editform/treeCodeInput/treeCodeInput.vue'
import boxWithLine from './editform/boxWithLine/boxWithLine.vue'
import setDefaultRadio from './editform/setDefaultRadio'
import selectOfInvoiceModalTable from './editform/selectOfInvoiceModalTable'
import businessFlowShow from './editform/businessFlowShow/businessFlowShow.vue'
import { selectAdvance, pgOption } from './editform/selectAdvance'
import panguInputNumber from './editform/panguInputNumber'
import panguInputNumberForPercent from './editform/panguInputNumberForPercent'
import scanInput from './editform/scanInput'
import componentForTooltip from './editform/componentForTooltip'
import addressInfoEdit from './editform/addressInfoEdit/addressInfoEdit.vue'
import addressInfoDetail from './editform/addressInfoDetail/addressInfoDetail.vue'
import partitionErect from './editform/partitionErect'
import batchNumberSelection from './editform/batchNumberSelection'
import registrationSelection from './editform/registrationSelection'
import sideslipSelect from './editform/sideslipSelect'
import serialNumberSelection from './editform/serialNumberSelection'
import serialNumberSelectionModel from './editform/serialNumberSelectionModel'
import sideSelect from './editform/sideSelect'
import scanCode from './scanCode'
import pgToolTip from './editform/pgToolTip'
import multipleInputNumber from './editform/multipleInputNumber'
import {
  scanStandard,
  scanSimple,
  scanTable,
  scanSimpleInput,
  scanBasic,
  scanBasicInput,
  scanBasicAndSelectStock,
  scanAddPackage,
} from './scanNumber'
import {
  scanPlus,
  scanStandardPlus,
  scanBasicPlus,
  scanBasicInputPlus,
  scanBasicAndSelectStockPlus,
  scanSimpleInputPlus,
  scanAddPackagePlus,
  scanInputNumberPlus,
  scanRfidPlus,
  scanLabelSwitch,
} from './scanNumberPlus'
import excelReplace from './side/excelReplace'
import sideScanCode from './side/sideScanCode'
import sideScanCodeAdd from './side/sideScanCode/sideScanCodeAdd'
import sideScanCodeCheck from './side/sideScanCode/sideScanCodeCheck'
import sideAdd from './editform/sideAdd'
import sideAddCode from './editform/sideAddCode'
import sideAddPlus from './editform/sideAddPlus'
import panguDatePicker from './editform/panguDatePicker'
import logisticsInformation from './editform/logisticsInformation'
import showInventory from './editform/showInventory'
import curdEditFooterButtonGroup from './curdEditFooterButtonGroup'
import hoverPoptip from './editform/hoverPoptip'
import selectTemplateModal from './editform/selectTemplateModal'
import selectTemplateModalOld from './editform/selectTemplateModal/selectTemplateModal_old.vue'
import selectTemplateAndAmountForRfid from './editform/selectTemplateModal/selectTemplateAndAmountForRfid.vue'

import cloudPrint from './editform/cloudPrint'

import dataRefreshOfTable from './editform/dataRefreshOfTable'
import contentTransform from './editform/contentTransform'
import readTextOfSideFrom from './editform/readTextOfSideFrom'
import serialNumberToOrder from './editform/serialNumberToOrder'
import organizationDetail from './editform/organizationDetail'
import editRemarks from './editform/editRemarks'
import logistics from './editform/logistics'
import receiverAddress from './editform/receiverAddress'
import pageTable from './editform/pageTable'
import modalTable from './editform/modalTable'
import buttonSideModal from './editform/buttonSideModal'
import buttonModal from './editform/buttonModal'
import filterOfTableHeader from './editform/panguTable/filterOfTableHeader.vue'
import buttonForLeadIn from './editform/buttonForLeadIn'
import buttonForFolderIn from './editform/buttonForFolderIn'
import buttonForCard from './editform/buttonForCard'
import addressEdit from './editform/addressEdit'
import newAddressEdit from './editform/newAddressEdit'
import formItemClickForGroup from './editform/formItemClickForGroup'
import flashAddMedicalAndCurdArray from './editform/flashAddMedicalAndCurdArray'
import realPageTable from './editform/realPageTable'
import readTextNotUseVModel from './editform/readTextNotUseVModel'
import dataRefreshAndShow from './editform/dataRefreshAndShow'
import discountEdit from './editform/discountEdit'
import validDateCompute from './editform/validDateCompute'
import sideAsyncAdd from './editform/sideAsyncAdd'
import proportionInput from './editform/proportionInput'
import setEmptyValue from './editform/setEmptyValue'
import formulaSite from './editform/formulaSite'
import countTo from './editform/countTo/CountTo.vue'
import dateGroup from './editform/dateGroup'
import modalMedical from './modalMedical'
import ReferCreate from './referCreate/ReferCreate'
import ReferCreateDetail from './referCreate/ReferCreate-detail'
import autoComplete from './editform/autoComplete'
import alertModal from './editform/alertModal'
import pgRate from './editform/pgRate'
import numberCoding from './numberCoding/numberCoding.vue' // 验收赋码
import numberGoods from './numberGoods/numberGoods.vue' // 商品数量（侧滑查看）
import inputExcelCopy from './editform/input-excel-copy'
import goodsSelect from './editform/goodsSelect'
import modalGoodsSelect from './editform/modalGoodsSelect'
import bindFieldRelation from './editform/bindFieldRelation'
import alertMessage from './editform/alertMessage'
import showTwoContent from './showTwoContent/showTwoContent.vue'
import collapseExpand from './collapseExpand/index.js'

//新的动态表单
import panguForm from './pangu-form'
import panguFormPage from './pangu-form-page'
// 待历史修改记录的动态表单
import panguFormHistory from './pangu-form-history'
import panguFormPageHistory from './pangu-form-page-history'

import collapseTransition from './collapse-transition'

// 动态表单-布局
import iconDiv from './editform/layout/iconDiv'
import layoutMain from './layoutTemplate/layoutMain.vue'

// 标准业务sotre
import menuStore from './layoutTemplate/store/newMenuStore'
import user from './layoutTemplate/store/user'
import strategy from './layoutTemplate/store/strategy'
import formModifyStore from './layoutTemplate/store/formModifyStore'
import layoutCommon from './layoutTemplate/store/layoutCommon'

// 购物车模型
import shoppingModel from './shoppingModel/shoppingModel'
import shoppingModelPlus from './shoppingModel/shoppingModelPlus'

import qrCode from './qrCode/index'
import range from './range/index'
import pgSwitch from './pgSwitch/index'
import checkBox from './checkBox/index'

// 大屏
import monitoring from './fullscreen/components/editForm/monitoring/monitoring.vue'

// 用于直接注册的组件
const componentsOfInstall = {
  previewPicture,
  previewAttachment,
  previewAttachmentPlus,
  previewPictureForSimple,
  dynamicFromItem,
  sideAsyncAdd,
  dynamicFrom,
  headerTit,
  htmlText,
  selectRemote,
  panguSelect,
  sideSetScope,
  sideAsynRefresh,
  sideExport,
  sideAddLicenses,
  panguTag,
  selectOfModalTable,
  keywordOfModalTable,
  inputSelectOfModalTable,
  referencePrice,
  keywordSearchTable,
  cascaderRemote,
  crudQuery,
  shortcutQuery,
  crudDoubleQuery,
  crudQueryAndFullScreen,
  fullscreen,
  crudSpectaculars,
  crudQuerys,
  crudDoubleQuerys,
  queryToolbar,
  crudEdit,
  crudEditOrder,
  navigation,
  copyright,
  panguSideModal,
  imageEditor,
  panguDraggableList,
  shuttleBoxModal,
  shuttleBoxSide,
  anchorGo,
  anchorGoLink,
  panguPopTip,
  tableOfSideModal,
  groupLabel,
  groupBlank,
  groupDashed,
  emptyItem,
  crudEditForSideModal,
  crudQueryForSideModal,
  readTextPlus,
  readText,
  readTextTwo,
  arrToStr,
  treeEdit,
  treeEditRole,
  objectJsonEdit,
  objectJsonEditAPI,
  inputJson,
  panguTable,
  modelInputNumber,
  crudArray,
  crudArrayOrder,
  dataTable,
  crudDataTable,
  workflowDiagramEdit,
  editInTable,
  iconSelect,
  uploadNormal,
  uploadAttachment,
  radioRemote,
  checkboxRemote,
  layoutMain,
  iconDiv,
  draggableContainer,
  draggableTreeContainer,
  treeClassify,
  handle,
  leadLoading,
  proportion,
  proportionWithUnit,
  panguAutoComplete,
  treeOfModal,
  storageCondition,
  auditComent,
  cellStatus,
  tagColor,
  readTextColorAndTitle,
  newCellStatus,
  commonPartShow,
  formItemClick,
  goodsItemClick,
  cellBoolean,
  approvalStepDisplay,
  approvalTimelineModal,
  flashAddMedical,
  excelCopyForFlash,
  flashAddMedicalEidt,
  flashAddMedicalModalTable,
  flashAddMedicalForProduct,
  flashAddMedicalLight,
  flashAddMedicalSuper,
  flashAddMedicalSuperForProduct,
  treeTable,
  confirmTip,
  yearSelectModel,
  treeCodeInput,
  emptyPage,
  returnTop,
  queryGroup,
  setDefaultRadio,
  selectAdvance,
  panguInputNumber,
  panguInputNumberForPercent,
  scanInput,
  componentForTooltip,
  pgOption,
  boxWithLine,
  addressInfoDetail,
  addressInfoEdit,
  partitionErect,
  batchNumberSelection,
  registrationSelection,
  sideslipSelect,
  serialNumberSelection,
  sideSelect,
  scanCode,
  scanStandard,
  scanSimple,
  scanTable,
  scanSimpleInput,
  scanBasic,
  scanBasicInput,
  scanBasicAndSelectStock,
  scanAddPackage,
  scanPlus,
  scanStandardPlus,
  scanBasicPlus,
  scanBasicInputPlus,
  scanBasicAndSelectStockPlus,
  scanSimpleInputPlus,
  scanAddPackagePlus,
  scanInputNumberPlus,
  scanRfidPlus,
  scanLabelSwitch,
  excelReplace,
  sideScanCode,
  sideScanCodeCheck,
  sideScanCodeAdd,
  panguDatePicker,
  saveTemplateModal,
  depositCalcModal,
  depositCalcSide,
  depositCalcUse,
  logisticsInformation,
  showAttachment,
  uploadModal,
  showInventory,
  curdEditFooterButtonGroup,
  popTipOfMessage,
  pollMessage,
  selectOfInvoiceModalTable,
  businessFlowShow,
  modalProgress,
  modalAlike,
  modalUpdateResult,
  hoverPoptip,
  modalCheckUpdate,
  buttonOfSynchroData,
  modalFrom,
  batchReplaceModel,
  batchReplaceModelPlus,
  batchUpdateAmountModal,
  selectTemplateModal,
  selectTemplateModalOld,
  selectTemplateAndAmountForRfid,
  cloudPrint,
  dataRefreshOfTable,
  topRemind,
  newTopRemind,
  sendIbpHint,
  findBi,
  handleTip,
  copyExcelInput,
  contentTransform,
  readTextOfSideFrom,
  serialNumberToOrder,
  fMSuperSearchModal,
  fMSuperForProductSearchModal,
  organizationDetail,
  editRemarks,
  logistics,
  receiverAddress,
  pageTable,
  modalTable,
  buttonSideModal,
  buttonModal,
  filterOfTableHeader,
  messageNeedCare,
  downloadApp,
  panguSpin,
  buttonForLeadIn,
  buttonForFolderIn,
  buttonForCard,
  progressTask,
  addressEdit,
  newAddressEdit,
  serialNumberSelectionModel,
  sideAdd,
  sideAddCode,
  sideAddPlus,
  realPageTable,
  formItemClickForGroup,
  flashAddMedicalAndCurdArray,
  readTextNotUseVModel,
  dataRefreshAndShow,
  discountEdit,
  sideContainsComponent,
  jumpManage,
  portal,
  portalItem,
  ErrorPage404,
  validDateCompute,
  sideTableSubmitForm,
  proportionInput,
  setEmptyValue,
  formulaSite,
  countTo,
  dateGroup,
  modalMedical,
  ReferCreate,
  ReferCreateDetail,
  autoComplete,
  alertModal,
  pgRate,
  numberCoding,
  numberGoods,
  inputExcelCopy,
  productCatlog,
  productCard,
  acdSee,
  productDetail,
  productCart,
  productSupplement,
  addGoods,
  panguTab,
  goodLists,
  goodQuery,
  goodQueryBh,
  productNav,
  productProcess,
  productCardForGood,
  SideDoubleTableSelect,
  SideTableSelect,
  bookKeeping,
  bookKeepingForMink,
  upAndDown,
  popupSelection,
  queryGroupPlus,
  scanNumberAndPopUp,
  modalScanNumberAndPopUp,
  goodsSelect,
  modalGoodsSelect,
  collapseExpand,
  panguForm,
  panguFormPage,
  panguFormHistory,
  panguFormPageHistory,
  collapseTransition,
  pgToolTip,
  multipleInputNumber,
  qrCode,
  range,
  pgSwitch,
  checkBox,
  bindFieldRelation,
  alertMessage,
  showTwoContent,
  monitoring,
}
// 其他组件，按需引用
// const otherComponents = {
//     crudEditOfDesign
// };

const panguComponents = {}
panguComponents.install = function (Vue) {
  Vue.use(Header).use(Footer).use(Column).use(Edit).use(Validator).use(Table)
  // 引入全局组件
  Object.keys(componentsOfInstall).forEach((key) => {
    Vue.component(key, componentsOfInstall[key])
  })

  //
  // Vue.component('layoutMain', layoutMain);
}

const panguStore = {
  menuStore,
  user,
  formModifyStore,
  layoutCommon,
  strategy,
}
export default panguComponents

export {
  // otherComponents,
  // formCreate,
  panguComponents,
  panguStore,
  filters,
  filter,
  moment,
  // 其他组件，按需引用
  crudEditOfDesign,
  shoppingModel,
  shoppingModelPlus,
  portal,
  portalItem,
  countTo,
} // eslint-disable-line no-undef
